import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { getStoredAccessToken } from '../authentication'

const httpLink = createHttpLink({
  uri: 'https://api.linear.app/graphql'
})

const authLink = setContext((_, { headers }) => {
  const token = getStoredAccessToken()
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

export const linearClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
})
